import { useEffect, useState } from 'react';

function Spinner({ size = 111 }) {
  const [loadingText, setLoadingText] = useState('');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoadingText('Cargando…');
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="overlay" data-cy="spinner">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{
          margin: 'auto',
          display: 'block',
        }}
        width={`${size}px`}
        height={`${size}px`}
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="#0066FF"
          strokeWidth="8"
          r="35"
          strokeDasharray="164.93361431346415 56.97787143782138"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="1.5384615384615383s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          />
        </circle>
      </svg>
      <span className="spinner-hidden" role="status" aria-live="polite">
        {loadingText}
      </span>
      <style jsx>
        {`
          .overlay {
            position: absolute;
            top: 0px;
            left: 0px;
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            z-index: 99;
            border-radius: 4px;
            backdrop-filter: blur(10px);
          }

          .spinner-hidden {
            position: absolute;
            width: 1px;
            height: 1px;
            margin: -1px;
            padding: 0;
            overflow: hidden;
            white-space: nowrap;
            border: 0;
          }
        `}
      </style>
    </div>
  );
}
export default Spinner;
